import { createContext } from 'react';

export const ObfuscateNameContext = createContext(false);
